// extracted by mini-css-extract-plugin
module.exports = {"toast-info":"styles_toast-info__2CYzO","toast-info--icon":"styles_toast-info--icon__2oAct","toast-info--text":"styles_toast-info--text__2IJea"};